<template>
    <div class="bidding-controls">
        <div class="bidding-controls__grid">
            <template v-if="priceHints"
                ><label v-for="hint in priceHints" :key="hint.amount" class="bidding-controls__recommended-button">
                    <input type="radio" class="d-none" v-model="presetAmount" :value="hint.amount" />
                    <span>{{ formatPrice(hint.amount) }}</span>
                </label></template
            >

            <div class="bidding-controls__other-amount">
                <span class="text-nowrap">{{ $t('BiddingControls.otherAmount') }}</span>

                <BidInput v-model="inputAmount" :placeholder="placeholder" class="text-right" />
            </div>
        </div>

        <div v-if="highlightedAmount" class="bidding-controls__legend">
            <i class="bidding-controls__legend-icon"></i>

            <span>{{ $t('BiddingControls.recommendedMinBid') }}</span>
        </div>
    </div>
</template>

<script>
import formatPrice from '@/filters/formatPrice';
import BidInput from '@/components/product/auction/BidInput.vue';

export default {
    name: 'BiddingControls',
    components: { BidInput },
    methods: { formatPrice },

    data() {
        return {
            presetAmount: null,
            presetAmountCache: null,
            inputAmount: null,
            resultAmount: null
        };
    },

    props: {
        priceHints: {
            type: Array
        }
    },

    computed: {
        highlightedAmount() {
            const recommended = (this.priceHints || []).find(h => h.highlighted);
            if (recommended) {
                return recommended.amount;
            }
        },

        placeholder() {
            if (this.highlightedAmount) {
                return `${this.$t('Generic.recommended')}: ${formatPrice(this.highlightedAmount)}`;
            }
        }
    },

    created() {
        if (this.highlightedAmount) {
            this.presetAmount = this.highlightedAmount;
        }
    },

    watch: {
        presetAmount(amount) {
            if (amount) {
                // amount can be null if bid input gets value (to deselect preset buttons)
                this.presetAmountCache = amount;
                this.inputAmount = null;
                this.resultAmount = amount;
            }
        },

        inputAmount(amount) {
            if (amount) {
                this.presetAmount = null;
                this.resultAmount = amount;
            } else {
                this.presetAmount = this.presetAmountCache;
            }
        },

        resultAmount(value) {
            if (value) {
                // cannot emit empty or zero value, checkout link is always active
                this.$emit('change', value);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.bidding-controls {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    &__grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0.5rem;
    }

    &__recommended-button {
        padding: 0.8rem 1rem;
        align-content: center;
        margin-bottom: 0;
        border: 1px solid var(--border-color);
        cursor: pointer;

        &:has(:checked),
        &:focus-visible,
        &:hover {
            border-color: var(--primary);
            box-shadow: 0 5px 18px hsla(0, 0%, 0%, 0.25);
            background-color: var(--white);
        }
    }

    &__other-amount {
        grid-column: 1 / -1;
        display: flex;
        gap: 1rem;
        flex-wrap: nowrap;
        align-items: center;
    }

    &__legend {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    &__legend-icon {
        aspect-ratio: 15 / 9;
        height: 1em;
        border: 1px solid var(--primary);
        background-color: var(--white);
    }
}
</style>
